package com.downdogapp

enum class KeyStroke {
  SPACE,
  RIGHT,
  LEFT,
  UP,
  DOWN,
  ENTER;

  override fun toString(): String = name.lowercase()

  companion object {

    fun fromCode(code: String) =
      when (code) {
        "Space" -> SPACE
        "ArrowUp" -> UP
        "ArrowDown" -> DOWN
        "ArrowLeft" -> LEFT
        "ArrowRight" -> RIGHT
        "Enter" -> ENTER
        else -> null
      }
  }
}
